import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOC_API_URL,
});

instance.defaults.headers.common["Authorization"] = "xyzxcwaqerd784951623";
export default instance;
